import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '@services/config.service';
import { ExamineeloginService } from '@services/examineelogin.service';
import { WebErrorService } from '@services/webError.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ExamineeResetPasswordComponent implements OnInit {
  fullyear = new Date().getFullYear();
  loginForm: FormGroup;
  isSubmitted = false;
  loginSpinner = false;
  submitted = false;
  userServiceSubscription$: any;
  msg: any;
  loginErrorMessage: string;
  passwordReset: any;
  lockoutMsg: boolean = false;
  constructor(private fb: FormBuilder, private examineeLoginService: ExamineeloginService, public configService: ConfigService, private translate: TranslateService, private webErrorService: WebErrorService) { }

  ngOnInit(): void {
    // this.styleService.addStyle('login', require('../../../scss/login.css'));
    this.loginForm = this.fb.group({
      emailId: ["",
        [Validators.required,
        Validators.pattern('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}')
        // Validators.pattern(/^[a-zA-Z0-9]+([.]?[_]?[a-zA-Z0-9])*@[a-zA-Z0-9]+([\-\.]?[a-zA-Z0-9]+)*\.[A-Za-z]{1,3}$/)
        ]
      ]
    })
  }
  get f() { return this.loginForm.controls; }

  reset() {
    this.loginErrorMessage = '';
    this.lockoutMsg = false;
    this.submitted = true;
    if (this.loginForm.valid) {
      if(this.userServiceSubscription$){this.userServiceSubscription$.unsubscribe()}
      this.userServiceSubscription$ = this.examineeLoginService.resetPassword(this.loginForm.value.emailId).subscribe(
        (data: any) => {
          this.submitted = false;
          this.passwordReset = 'true';
          localStorage.setItem('resetPassword', this.passwordReset);
          this.msg = this.translate.instant('examineeLogin.forgotPwd.resetPwdMsg');
          this.loginErrorMessage = '';
        }, (error: any) => { this.loginErrorMessage = error.error.message;
          if (this.loginErrorMessage.match(this.translate.instant('userLogin.loginForm.errorMsg'))) this.lockoutMsg = true;
        });

      // this.loginForm.reset({
      //   'emailId' : ''
      // });
    }
  }
  ngOnDestroy() {
    if(this.userServiceSubscription$){this.userServiceSubscription$.unsubscribe()}
    // this.styleService.removeStyle('login');
  }
}
